<template>
  <h2>pagetwo</h2>
</template>

<script>
export default {

}
</script>

<style>

</style>